<template>
    <div>
        <b-container>
            <b-row class="justify-content-center">
                <b-col sm="10" md="9" lg="7">
                    <b-form v-show="view === 'formPartOne'">
                        <b-alert show>
                            <p>Recuerde que las solicitudes registradas de lunes a viernes después de las 12:00 m. (mediodía), así
                                como las registradas los días sábado o domingo, se consideran recibidas el próximo día útil.</p>
                        </b-alert>
                        <h2>TIPO DE DOCUMENTO</h2>
                        <b-form-group label="Documento">
                            <span>Elija el documento que desea solicitar</span>
                            <div class="box">
                                <b-form-checkbox-group id="chkg-TipoCertificado" v-model="form.TipoCertificado">
                                    <b-form-checkbox v-for="option in vm.tiposDocumento" :key="option.Id"
                                        :value="option.Id" class="my-1">
                                        {{ option.Title }}
                                    </b-form-checkbox>
                                </b-form-checkbox-group>
                            </div>
                        </b-form-group>

                        <b-form-group label="Constancia" v-if="form.TipoCertificado.filter(op => op == 1).length > 0">
                            <span>Por favor, escoja el idioma en que se emitirá su constancia de record académico por sus clases de Inglés.</span>
                            <div class="box">
                                <b-form-radio-group id="chkg-TipoCertificado" v-model="form.Subtipos[0]">
                                    <b-form-radio v-for="option in vm.tiposConstancia" :key="option.Id"
                                        :value="option.Id" class="my-1">
                                        {{ option.Title }}
                                    </b-form-radio>
                                </b-form-radio-group>
                            </div>
                        </b-form-group>

                        <b-form-group label="Certificado" v-if="form.TipoCertificado.filter(op => op == 2).length > 0">
                            <div class="box">
                                <b-form-radio-group id="chkg-TipoConstancia" v-model="form.Subtipos[1]">
                                    <b-form-radio v-for="option in vm.tiposCertificado" :key="option.Id"
                                        :value="option.Id" class="my-1">
                                        {{ option.Title }}
                                    </b-form-radio>
                                </b-form-radio-group>
                            </div>
                        </b-form-group>

                        <h2>DATOS DEL ALUMNO</h2>
                        <span>Registre sus nombres y apellidos conforme figuran en su DNI.</span>
                        <b-form-group label="Nombres">
                            <b-form-input v-model="form.Nombres" type="text"
                                :state="form.Nombres==null? null : !!form.Nombres"></b-form-input>
                        </b-form-group>
                        <b-form-group label="Apellidos">
                            <b-form-input v-model="form.Apellidos" type="text"
                                :state="form.Apellidos==null? null : !!form.Apellidos"></b-form-input>
                        </b-form-group>
                        <b-form-group label="Código de alumno">
                            <b-form-input v-model="form.CodigoAlumno" type="text"
                                :state="(form.CodigoAlumno == null ? null : ValidateNumber(form.CodigoAlumno))">
                            </b-form-input>
                        </b-form-group>
                        <b-form-group label="Nº Documento Identidad">
                            <span>DNI / Pasaporte / Carné extranjería</span>
                            <b-form-input v-model="form.DNI" type="text" :state="form.DNI==null? null : !!form.DNI">
                            </b-form-input>
                        </b-form-group>
                        <b-form-group label="Teléfono">
                            <b-form-input v-model="form.Telefono" type="text"
                                :state="form.Telefono==null? null : !!form.Telefono"></b-form-input>
                        </b-form-group>
                        <b-form-group label="Correo electrónico"
                            description="A través de este correo se realizará todo el trámite">
                            <b-form-input v-model="form.Email" type="text"
                                :state="form.Email==null? null : (!!form.Email && ValidateEmail(form.Email))">
                            </b-form-input>
                            <b-button class="btn-main" @click="enviarCodigoVerificacion">Enviar código de verificación</b-button>
                        </b-form-group>
                        <b-form-group v-if="form.CodigoVerificacionEnviado" label="Código de verificación" description="Código enviado a su correo">
                            <b-form-input v-model="form.CodigoVerificacion" type="text"
                                :state="form.CodigoVerificacion == null ? null : (!!form.CodigoVerificacion)">
                            </b-form-input>
                            <b-button class="btn-main" @click="validarCodigoVerificacion">Validar código de verificación</b-button>
                        </b-form-group>
                        <b-form-group>
                            <b-button class="btn-main px-4" @click="handleNext"
                                :disabled="!(form.VerifiedEmail && form.Email && (form.TipoCertificado.length > 0) && form.Nombres && form.Apellidos && form.Telefono && (form.CodigoAlumno == null || ValidateNumber(form.CodigoAlumno)) && (form.Email && ValidateEmail(form.Email)) && form.DNI && (form.TipoCertificado.filter(op => op == 1).length <= 0 || form.Subtipos[0]) && (form.TipoCertificado.filter(op => op == 2).length <= 0 || form.Subtipos[1]))">
                                Siguiente
                            </b-button>
                        </b-form-group>
                    </b-form>
                    <div v-if="view == 'formTyC'">
                        <b-form-group>
                            <h2>TÉRMINOS Y CONDICIONES</h2>
                            <p>Al hacer click en el botón "Enviar solicitud", usted estará aceptando los siguientes
                                términos y condiciones:</p>
                            <ol>
                                <li>Luego de completar este formulario, usted recibirá una copia en el correo
                                    electrónico registrado, donde podrá encontrar su N° ticket de atención.</li>
                                <li>Las solicitudes registradas de lunes a viernes después de las 12:00 m. (mediodía), así como las
                                    registradas los días sábado o domingo, se consideran recibidas el próximo día útil.</li>
                                <li>Los plazos de atención son contabilizados en día útiles, es decir, de lunes a
                                    viernes, sin contar los feriados.</li>
                                <li>Su solicitud será evaluada. En el plazo máximo de 3 días útiles, Ud. recibirá un
                                    mail de confirmación indicando si su solicitud procede o no. Podrá ubicar el mail con el asunto: <strong>Ticket CRT-XXXXXX – Documento solicitado - Nombres y Apellidos</strong> 
                                    (puede alojarse en su bandeja de Spam o correo no deseado).</li>
                                <li>Si su solicitud procede, encontrará las instrucciones a seguir junto con un link de pago en el mail de confirmación relacionado a su Ticket activo. Si realiza el pago con un link diferente, su solicitud será desestimada y se realizará un extorno a su tarjeta.</li>
                                <li>Ud. tendrá un plazo máximo de 2 días útiles para realizar el pago y adjuntar la imagen de su documento de identidad en la plataforma. Pasado este plazo, 
                                    su solicitud será desestimada y deberá registrar un nuevo Ticket. Si hubiera realizado el pago, se realizará automáticamente un extorno a su tarjeta (el plazo de extorno dependerá de su banco emisor).</li>
                                <li>El plazo de emisión del certificado/constancia es de 10 días útiles, contados desde el momento en que adjunte en la plataforma su documento de identidad.</li>
                                <li>La descarga del documento solicitado se puede realizar solo desde una PC o laptop. Estará habilitada por un plazo máximo de 6 meses, 
                                    contados desde el momento que se le notifique por correo electrónico. 
                                    El alumno asume la responsabilidad de la conservación del documento. Si lo pierde o elimina, deberá realizar un nuevo trámite y nuevo pago.</li>
                                <li>Deberá completar un formulario por cada documento que desee solicitar (certificado o
                                    constancia).</li>
                                <li>Los datos personales ingresados en este formulario serán utilizados por el BRITÁNICO
                                    únicamente para la atención de su solicitud, en cumplimiento de la Ley 29733 - Ley
                                    de protección de datos personales.</li>
                            </ol>
                        </b-form-group>
                        <b-form-group>
                            <vue-recaptcha ref="recaptcha" @verify="onVerify" @expired="onExpired"
                                sitekey="6LcRnskZAAAAAPvUexc-7yyr8LqIgcXguWV8MeFX"></vue-recaptcha>
                        </b-form-group>
                        <b-form-group>
                            <b-button class="btn-main px-4" @click="handleSubmit"
                                :disabled="!(form.Email && form.Recaptcha && (form.TipoCertificado.length > 0) && form.Nombres && form.Apellidos && form.Telefono && (form.CodigoAlumno == null || ValidateNumber(form.CodigoAlumno)) && (form.Email && ValidateEmail(form.Email)) && form.DNI && (form.TipoCertificado.filter(op => op == 1).length <= 0 || form.Subtipos[0]) && (form.TipoCertificado.filter(op => op == 2).length <= 0 || form.Subtipos[1]))">
                                Enviar solicitud
                            </b-button>
                        </b-form-group>
                        <b-form-group v-if="errors">
                            <div class="errors errors-save" v-html="errors"></div>
                        </b-form-group>
                    </div>
                    <div v-if="view === 'notification'" class="text-center notification">
                        <img :src="notification.icon" />
                        <h5 class="my-4">{{ notification.title }}</h5>
                        <p class="mb-5">{{ notification.description }}</p>
                        <b-button class="btn-alt px-4" @click="notification.handleAction">{{ notification.action }}
                        </b-button>
                    </div>
                    <b-overlay no-wrap :show="loading" opacity="1">
                        <template #overlay>
                            <div class="text-center">
                                <b-icon icon="stopwatch" font-scale="3" animation="cylon"></b-icon>
                                <p>Esto podrá tomar unos minutos.</p>
                            </div>
                        </template>
                    </b-overlay>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import {getTiposDocumento, saveSolicitudCertificado, getTiposCertificado, getTiposConstancia, sendTokenVerificacionCorreo, verificarCorreo } from '../../api/CounterApi';

export default {
    name: 'SolicitudCertificado',
    components: { VueRecaptcha },
    data(){
        return {
            form: {
                TipoCertificado: [],
                SubtipoCertificado: [],
                Email: null,
                CodigoAlumno: null,
                DNI: null,
                Nombres: null,
                Apellidos: null,
                Telefono: null,
                Recaptcha: '',
                VerifiedEmail: false,
                CodigoVerificacion: null,
                CodigoVerificacionEnviado: false,
                Subtipos: [null, null]
            },
            vm: {
                tiposConstancia: [],
                tiposCertificado: [],
                tiposDocumento: []
            },
            view: 'formPartOne',
            loading: false,
            options: [],
            notification: {},
            errors: null
        }
    },
    async created(){
        [this.vm.tiposDocumento, this.vm.tiposCertificado, this.vm.tiposConstancia] = await Promise.all([getTiposDocumento(), getTiposCertificado(), getTiposConstancia()]);
    },
    methods: {
        filterOptions(options) {
            return options.filter(option => !!option);
        },
        async handleNext() {
            this.loading = true;
            //procesar datos y obtener correo

            // let alumno = await getAlumno(this.form.Codigo);
            // if(alumno != null){
            //     //this.form.Correo = alumno.Email;
            //     this.form.PlaceHolderCorreo = alumno.Email;
            this.errors = null;
            this.view = 'formTyC';
            //     this.errors = null;
            // } else {
            //     this.errors = "Código de alumno inválido.";
            // }
            this.loading = false;            
        },
        handlePrev(){
            this.resetRecaptcha();
            this.view = 'formPartOne';
        },
        onVerify(res) {
            this.form.Recaptcha = res;
        },
        onExpired() {
            this.form.Recaptcha = '';
        },
        resetRecaptcha() {
            this.$refs.recaptcha.reset();
        },
        resetForm() {
            this.form = {
                TipoCertificado: [],
                SubtipoCertificado: [],
                Email: null,
                CodigoAlumno: null,
                DNI: null,
                Nombres: null,
                Apellidos: null,
                Telefono: null,
                Recaptcha: null,
                VerifiedEmail: false,
                CodigoVerificacionEnviado: false,
                CodigoVerificacion: null,
                Subtipos: [null, null]
            };
            
            if(this.$refs && this.$refs.recaptcha){ this.$refs.recaptcha.reset(); }
        },
        async enviarCodigoVerificacion() {
            this.loading = true;

            await sendTokenVerificacionCorreo(this.form.Email);

            this.form.CodigoVerificacionEnviado = true;
            this.loading = false;
        },
        async validarCodigoVerificacion() {
            this.loading = true;

            this.form.VerifiedEmail = false;
            const res = await verificarCorreo(this.form.Email, this.form.CodigoVerificacion);
            if (res.success) {
                this.form.VerifiedEmail = true;
            }

            this.loading = false;
        },
        async handleSubmit() {
            this.loading = true;

            let vmCert = this;
            //procesar y enviar datos
            let res = await saveSolicitudCertificado({
                code: this.form.Recaptcha,
                value: {
                    CodigoAlumno: this.form.CodigoAlumno,
                    Email: this.form.Email,
                    SubtipoCertificado: this.form.Subtipos.filter(s => !!s),
                    TipoCertificado: this.form.TipoCertificado,
                    DNI: this.form.DNI,
                    Nombres: this.form.Nombres,
                    Apellidos: this.form.Apellidos,
                    Telefono: this.form.Telefono,
                }
            });
            if(res.success){
                //envio correcto
                this.notification = {
                    icon: require('../../assets/success.svg'),
                    title: 'Solicitud enviada con éxito',
                    description: 'En breve, enviaremos los detalles de tu solicitud vía correo electrónico.',
                    action: 'Nueva solicitud',
                    handleAction: function(){
                        vmCert.resetForm(); 
                        vmCert.view = 'formPartOne'                        
                    }
                }   
                /*
                error
                this.notification = {
                    icon: require('../../assets/success.svg'),
                    title: '',
                    description: '',
                    action: '',
                }
                */
                this.resetForm();
                this.view = 'notification';
                this.loading = false;
                this.errors = null;
            } else {
                this.errors = res.message;
                this.loading = false;
            }
        },
        ValidateEmail(value) {
            let validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            return !!value.match(validRegex);
        },
        ValidateNumber(value) {
            let validRegex = /^[0-9]*$/;
            return !!(value.match(validRegex));
        }
    },
    watch: {
        'form.TipoCertificado': function(newVal){
            if(this.vm.tiposConstancia.filter(st => newVal.indexOf(st.TipoCertificado.Id) >= 0).length <= 0){
                this.form.Subtipos[0] = null;
            }
            if(this.vm.tiposCertificado.filter(st => newVal.indexOf(st.TipoCertificado.Id) >= 0).length <= 0){
                this.form.Subtipos[1] = null;
            }
        }
    }
}
</script>
<style>

.container {
    padding-top: 60px;
}
.form-group {
    margin-bottom: 2rem !important;
}

label:not(.custom-control-label), legend {
    color: #034087 !important;
    font-family: 'ProximaNova-SemiBold';
    font-size: 18px;
    padding-bottom: 1rem!important;
}

.box {
    overflow-y: auto;
    max-height: 160px;
    background-color: #ffffff;
    border: 2px solid #EFEDED;
    padding: 5px 12px;
}

.custom-control-input:checked ~ .custom-control-label::before, .btn-main {
    background-color: #034087 !important;
    border-color: #034087 !important;
}
.btn-alt {
    background-color: #EB0029 !important;
    border-color: #EB0029 !important;
}
.btn {
    font-family: 'ProximaNova-Regular' !important;
    border-radius: 0.5rem;
}
.btn:disabled {
    background-color: #EFEDED !important;
    border-color: #EFEDED !important;
}
.pointer {
    cursor: pointer;
}
.notification img {
    max-width: 140px
}
.notification h5 {
    color: #034087;
    font-family: 'ProximaNova-Bold';
}
.bg-light {
    background-color: #f6f6f6 !important;
}
.b-overlay {
    color: #40D7D7;
}
.b-overlay .spinner-border {
    height: 5rem;
    width: 5rem;
    border-width: 0.5rem;
}
.my-1{ display: block; }

.errors { color: #ff0000; font-size: 0.9em; }
.errors-save {
    display: block;
}
</style>